module.exports = __webpack_public_path__ + "assets/img/avatar_empty.8548b941.jpg";